import React from 'react';

import PropTypes from 'prop-types';
import {FormikErrors, withFormik} from 'formik';

import {FieldShape} from 'commons/shapes';
import {Messages} from 'commons/constants';
import {InferPropTypes} from 'commons/types/Types';
import InnerFormPersonalInfo from './InnerFormPersonalInfo';
import {formValidator, setDefaultValue} from 'commons/utils/Functions';
import {BeneficiaryServiceRequest} from 'commons/models/dtos/clients/Client';

PersonalInfoForm.propTypes = {
    tempBeneficiary: PropTypes.any,
    viewId: PropTypes.number.isRequired,
    viewKey: PropTypes.string.isRequired,
    fieldHandler: PropTypes.func.isRequired,
    submitHandler: PropTypes.func.isRequired,
    currentPercentage: PropTypes.number.isRequired,
    accumulatedPercentage: PropTypes.number.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
};

function validatePercentage(
    participationPercent: number,
    globalPercentage: number,
    currentPercentage: number,
    errors: any
) {
    if (Number(participationPercent) + Number(globalPercentage) - Number(currentPercentage) > 100) {
        errors.participationPercent =
            'El porcentaje de participaci\u00F3n total no puede superar el 100%';
    } else if (participationPercent < 1) {
        errors.participationPercent = Messages.INVALID_PARTICIPATION_PERCENTAGE;
    }
}

const FormControl = withFormik<
    InferPropTypes<typeof PersonalInfoForm.propTypes>,
    BeneficiaryServiceRequest
>({
    mapPropsToErrors: () => {
        return {
            expedientId: '',
            workflowId: '',
            viewId: '',
            viewFatherId: '',
            kycId: '',
            name: '',
            lastName: '',
            secondLastName: '',
            gender: '',
            birthDate: '',
            countryOrigin: '',
            stateOrigin: '',
            countryNationality: '',
            participationPercent: '',
            fatherKycId: '',
            foreignCitizen: '',
        };
    },
    mapPropsToValues: (props) => {
        const {tempBeneficiary} = props;
        if (tempBeneficiary) {
            return {
                expedientId: setDefaultValue(tempBeneficiary.expedientId, 0),
                workflowId: setDefaultValue(tempBeneficiary.workflowId, 0),
                viewId: setDefaultValue(tempBeneficiary.viewId, 0),
                viewFatherId: setDefaultValue(tempBeneficiary.viewFatherId, 0),
                kycId: setDefaultValue(tempBeneficiary.kycId, 0),
                name: setDefaultValue(tempBeneficiary.name, ''),
                lastName: setDefaultValue(tempBeneficiary.lastName, ''),
                secondLastName: setDefaultValue(tempBeneficiary.secondLastName, ''),
                gender: setDefaultValue(tempBeneficiary.gender, ''),
                birthDate: setDefaultValue(tempBeneficiary.birthDate, ''),
                countryOrigin: setDefaultValue(tempBeneficiary.countryOrigin, ''),
                stateOrigin: setDefaultValue(tempBeneficiary.stateOrigin, ''),
                countryNationality: setDefaultValue(tempBeneficiary.countryNationality, ''),
                participationPercent: setDefaultValue(
                    tempBeneficiary.participationPercent,
                    undefined
                ),
                fatherKycId: setDefaultValue(tempBeneficiary.fatherKycId, 0),
                foreignCitizen: setDefaultValue(tempBeneficiary.foreignCitizen, false),
            };
        } else {
            return {
                expedientId: 0,
                workflowId: 0,
                viewId: 0,
                viewFatherId: 0,
                kycId: 0,
                name: '',
                lastName: '',
                secondLastName: '',
                gender: '',
                birthDate: '',
                countryOrigin: '',
                stateOrigin: '',
                countryNationality: '',
                participationPercent: undefined,
                fatherKycId: 0,
                foreignCitizen: false,
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: BeneficiaryServiceRequest, props) => {
        const errors: FormikErrors<BeneficiaryServiceRequest> = {};
        formValidator(props.fields, errors, values);
        if (values.participationPercent) {
            validatePercentage(
                values.participationPercent,
                props.accumulatedPercentage,
                props.currentPercentage,
                errors
            );
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormPersonalInfo);
function PersonalInfoForm(props: InferPropTypes<typeof PersonalInfoForm.propTypes>) {
    const {
        fields,
        viewId,
        viewKey,
        fieldHandler,
        submitHandler,
        tempBeneficiary,
        currentPercentage,
        accumulatedPercentage,
    } = props;
    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            viewKey={viewKey}
            viewId={viewId}
            fields={fields}
            fieldHandler={fieldHandler}
            submitHandler={submitHandler}
            tempBeneficiary={tempBeneficiary}
            currentPercentage={currentPercentage}
            accumulatedPercentage={accumulatedPercentage}
        />
    );
}

export default PersonalInfoForm;
